import styled from 'styled-components'

export const StyledTableWrapper = styled.div`
  overflow: auto;
  
  table {
    min-width: 1060px;
  }
`
